/**
 * Storage Monitor Utility
 * 
 * This utility monitors localStorage and sessionStorage for changes
 * to help debug OIDC authentication flow issues.
 * 
 * TODO: Remove before production deployment
 */

let storageMonitorInterval: NodeJS.Timeout | null = null;
let lastStorageState: { local: Record<string, string>; session: Record<string, string> } | null = null;

export const startStorageMonitor = (): void => {
  const captureStorageState = () => {
    const local: Record<string, string> = {};
    const session: Record<string, string> = {};
    
    // Capture all storage keys (not just auth-related ones)
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        local[key] = localStorage.getItem(key) || '';
      }
    }
    
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key) {
        session[key] = sessionStorage.getItem(key) || '';
      }
    }
    
    return { local, session };
  };
  
  const compareAndLogChanges = (current: typeof lastStorageState, previous: typeof lastStorageState) => {
    if (!previous || !current) return;
    
    // Storage monitoring is now silent - changes are tracked internally
    // but no longer logged to console
  };
  
  // Initial capture
  lastStorageState = captureStorageState();
  
  // Monitor every 1 second
  storageMonitorInterval = setInterval(() => {
    const currentState = captureStorageState();
    compareAndLogChanges(currentState, lastStorageState);
    lastStorageState = currentState;
  }, 1000);
};

export const stopStorageMonitor = (): void => {
  if (storageMonitorInterval) {
    clearInterval(storageMonitorInterval);
    storageMonitorInterval = null;
  }
};

// Auto-start monitor when module loads if we're in callback context
if (window.location.pathname === '/login/callback' || window.location.search.includes('code=')) {
  startStorageMonitor();
  
  // Auto-stop after 30 seconds
  setTimeout(() => {
    stopStorageMonitor();
  }, 30000);
}
